export default __webpack_public_path__ + "static/media/membership.ffa06b04.jpeg";